<template>
  <ss-modal
    v-show="isModalVisible"
    title="Title"
    class="xs"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot= "modal-header">
      Nadano sygnaturę
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <div class="form-group">
        <ss-input
          v-model="signature_number"
          name="signature-number"
          label="Numer sygnatury"
          placeholder="Numer sygnatury">
        </ss-input>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="receivedSignature"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal'
import LarErrors from '@/helpers/Errors';

export default {
  name: 'SignatureGivenModal',
  components: {
    SsModal,
    LarErrors
  },
  props: {
    clauseSignatureId: {
      type: Number,
      default: 0
    },
    isModalVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionInProgress: false,
      lar_errors: LarErrors,
      signature_number: null
    }
  },
  methods: {
    receivedSignature(){
      this.actionInProgress = true;
      let _errors = {};
      let _count = 0;

      if (!this.signature_number) {
        _count++;
        _errors.signature_number = ['Pole Numer sygnatury jest wymagane.'];
      }
      if (_count > 0) {
        this.actionInProgress = false;
        this.lar_errors.record(_errors)
      }
      else {
        axios.post('api/clause-signatures/update-signature', {
          id: this.clauseSignatureId,
          signature_number: this.signature_number
        }).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Nadano sygnaturę akt klauzuli wykonalności.',
            showConfirmButton: true,
          }).then(() => {
            this.actionInProgress = false;
            this.$bus.$emit('reload-contract');
          });
          this.actionInProgress = false;
        }).catch((error) => {
          this.actionInProgress = false;
          LarErrors.record(error.response.data.errors)
        })
      }
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('signature-given-modal-close');
      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
    }
  }
}
</script>
